import { useTranslation } from 'react-i18next';

import { LegalTextStyles } from '../legal-text-styles';

const ModalPrivacy: React.FC<any> = () => {
  const { t } = useTranslation(['privacy']);
  return (
    <LegalTextStyles>
      <div className="legal-text">
        <h1>{t('privacy:title')}</h1>
        <p>{t('privacy:text-1')}</p>
        <ul>
          <li>{t('privacy:text-2')}</li>
          <li>{t('privacy:text-3')}</li>
          <li>{t('privacy:text-4')}</li>
        </ul>
        <h2>{t('privacy:subtitle-1')}</h2>
        <ul>
          <li>{t('privacy:text-5')}</li>
          <li>{t('privacy:text-6')}</li>
          <li>{t('privacy:text-7')}</li>
          <li>{t('privacy:text-8')}</li>
        </ul>
        <h2>{t('privacy:subtitle-2')}</h2>
        <ul>
          <li>{t('privacy:text-9')}</li>
        </ul>
        <h2>{t('privacy:subtitle-3')}</h2>
        <p>{t('privacy:text-10')}</p>
        <h2>{t('privacy:subtitle-4')}</h2>
        <p>{t('privacy:text-11')}</p>
        <ul>
          <li>{t('privacy:text-12')}</li>
          <li>{t('privacy:text-13')}</li>
          <li>{t('privacy:text-14')}</li>
          <li>{t('privacy:text-15')}</li>
          <li>{t('privacy:text-16')}</li>
          <li>{t('privacy:text-17')}</li>
          <li>{t('privacy:text-18')}</li>
        </ul>
        <p></p>
      </div>
    </LegalTextStyles>
  );
};

export default ModalPrivacy;
